module.exports = __webpack_public_path__ + "_placa_compra_inteligente.png?28846adfc607a68ba74fb9dddf235080";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/_placa_compra_inteligente.png
// module id = 116
// module chunks = 0